import AdvanceLabelForm from './advance/advanceLabelForm';

import Artist from './artist/ArtistForm';
import CashFlow from './cash-flow/CashFlowForm';
import ChannelVideo from './channel-video/ChannelVideoForm';
import Channel from './channel/ChannelForm';
import ClientAccount from './client-account/ClientAccountForm';
import ClientUser from './client-user/ClientUserForm';
import Contract from './contract/ContractForm';
import FtpConnection from './ftp-connection/FtpConnectionForm';
import SftpConnection from './sftp-connection/SftpConnectionForm';
import BlobConnection from './blob-connection/BlobConnectionForm';
import Label from './label/LabelForm';
import Merch from './merch/MerchForm';
import MusicProductDigital from './music-product-digital/MusicProductDigitalForm';
import MusicProductPhysical from './music-product-physical/MusicProductPhysicalForm';
import Provider from './providers/ProviderForm';
import SaleChannel from './sales-channel/SalesChannelForm';
import ApplicationSettings from './settings/ApplicationSettingsForm';
import LicenseSettings from './settings/LicenseSettingsForm';
import NotificationSettings from './settings/notifications/NotificationSettingsForm';
import ExchangeRates from './statements/ExchangeRatesForm';
import Rows from './statements/tabs/Rows';
import Track from './track/TrackForm';
import User from './user/UserForm';
import Video from './video/VideoForm';

import Email from './email/EmailForm';
import EventCashFlow from './event-cash-flow/EventCashFlowForm';
import Event from './event/EventForm';

export default {
  Artist,
  Track,
  Label,
  User,
  ClientUser,
  MusicProductDigital,
  MusicProductPhysical,
  Contract,
  SaleChannel,
  ExchangeRates,
  Rows,
  Merch,
  CashFlow,
  Provider,
  Channel,
  AdvanceLabelForm,
  ApplicationSettings,
  NotificationSettings,
  LicenseSettings,
  ChannelVideo,
  ClientAccount,
  Video,
  FtpConnection,
  SftpConnection,
  BlobConnection,
  Email,
  Event,
  EventCashFlow,
};
